import { forwardRef, type ElementType, type HTMLAttributes } from 'react';
import type { Interpolation, Theme } from '@emotion/react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { getFontColorClassName, getTextAlignClassName, type FontColorType } from '../../helpers';
import {
  getTextSizeClassName,
  getTextWeightClassName,
  textBaseStyle,
  type FontWeight,
  type TextAlignment,
  type TextSize,
} from './text-style-helpers';

type DragProps = Pick<HTMLAttributes<HTMLElement>, 'draggable' | 'onDragStart' | 'onDragEnd'>;

export type TextProps = CommonHTMLAttributes & {
  color?: FontColorType;
  as?: ElementType;
  size?: TextSize;
  textAlign?: TextAlignment;
  weight?: FontWeight;
  css?: Interpolation<Theme>;
} & DragProps;

export const Text = forwardRef<HTMLElement, TextProps>(
  (
    { size = 'large', weight = 'inherit', color = 'default', textAlign, as = 'p', className, css, children, ...props },
    ref
  ) => {
    const Component = as;
    return (
      <Component
        ref={ref}
        className={cx(
          textBaseStyle,
          getTextSizeClassName(size),
          getTextWeightClassName(weight),
          getFontColorClassName(color),
          textAlign && getTextAlignClassName(textAlign),
          className
        )}
        css={css}
        {...props}
      >
        <>{children}</>
      </Component>
    );
  }
);

Text.displayName = 'Text';
